import { render, staticRenderFns } from "./SoporteList.vue?vue&type=template&id=f1317486&scoped=true"
import script from "./SoporteList.vue?vue&type=script&lang=js"
export * from "./SoporteList.vue?vue&type=script&lang=js"
import style0 from "./SoporteList.vue?vue&type=style&index=0&id=f1317486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1317486",
  null
  
)

export default component.exports